import ToolTip from "../../ToolTip/ToolTip";

const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const CRO_SESSION_PREFERENCE_TABLE = [
  { field: "sl_no", headerName: "Sl No", width: 100 },
  {
    field: "subject",
    headerName: "Subject",
    width: 200,
  },
  {
    field: "week_day",
    headerName: "Week Day",
    width: 150,
    valueGetter: (params) => weekDays[params.value] || "Unknown",
  },
  { field: "from_time", headerName: "From Time", width: 150 },
  { field: "to_time", headerName: "To Time", width: 150 },
  { field: "created_at", headerName: "Created At", width: 200 },
];
